import { render, staticRenderFns } from "./EmailSideBar.vue?vue&type=template&id=fba69b8a&scoped=true"
import script from "./EmailSideBar.vue?vue&type=script&lang=js"
export * from "./EmailSideBar.vue?vue&type=script&lang=js"
import style0 from "./EmailSideBar.vue?vue&type=style&index=0&id=fba69b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba69b8a",
  null
  
)

export default component.exports